import React from 'react'
const Faculties = () => {
    return (
        <div>
            <div className='w-full p-4 bg-[#f2f2f2]'>
                <h1 className='flex justify-center text-4xl font-semibold'>Faculties</h1>
            </div>
            <div className='max-w-[95%] sm:max-w-[80%] mx-auto pb-2 '>
                <div className='border border-gray-50 shadow-2xl'>
                    <div>
                        <div className='bg-[#13263a] text-white text-2xl flex justify-center'><h1>Science Faculty</h1></div>
                        <div className='pl-[15px] sm:pl-16 pb-5'>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Computer Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Sri Satya Narayan Singh- (Assistant Professor)-(7007094927)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'> Mathematics Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Gyan Prakash Tripathi - (Associate Professor and H.O.D.)-(8173849325)</li>
                                        <li>Dr. Harsh Wardhan Singh - (Assistant Professor) -(7017993519)</li>
                                        <li>Sri Saurabh Shukla - (Assistant Professor) -(8853665035)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'> Chemistry Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Sri Alok Kumar Singh - (Assistant Professor and H.O.D.) -(8874787602)</li>
                                        <li>Sri Kartikeya - (Assistant Professor) -(9616828814)</li>
                                        <li>Sri Abhishek Maurya - (Assistant Professor) -(9598097579)</li>
                                        <li>Sri Gaurav Singh - (Assistant Professor) -(9336160124)</li>
                                        <li>Sri Kuldeep Kumar - (Assistant Professor) -(8052225784)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Zoology  Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Sri Sanjay Chaurasiya - (Assistant Professor) -(9149304138)</li>
                                        <li>Sri Akhilesh Chand Nishad - (Assistant Professor) -(6388460818)</li>
                                        <li>Dr. Brijesh Ranjan - (Assistant Professor) -(9125931098)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Botany  Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr.(Smt.) Poonam Singh - (Assistant Professor and H.O.D.) -(9415893801)</li>
                                        <li>Sri Akshay Kumar - (Assistant Professor) -(9452971641)</li>
                                        <li>Sri Brijesh Ranjan - (Assistant Professor) -(9839592108)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Physics Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Anil Kumar Singh - (Assistant Professor and H.O.D.)-(9450339841)</li>
                                        <li>Sri Ramjeet - (Assistant Professor)-(9451982891)</li>
                                        <li>Sri Sunil Kumar Sharma - (Assistant Professor)-(7571064812)</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='bg-[#13263a] text-white text-2xl flex justify-center'><h1>Arts Faculty</h1></div>
                        <div className='pl-[15px] sm:pl-16 pb-5'>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Political Science Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Praveen Kumar Singh - (Professor and Principal)-(9415234400)</li>
                                        <li>Dr. Vinod Kumar Yadav - (Assistant Professor)-(9810226204)</li>
                                        <li>Dr. Chandra Shekhar Srivastava - (Assistant Professor)-(9451890821)</li>
                                        <li>Dr. Saumitra Singh -(Assistant Professor)-(9838463034)</li>
                                        <li>Dr. Kalpana Singh -(Assistant Professor)-(9452977700)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Defence & Strategic Studies Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Manoj Kumar Mishra - (Professor)-(9452765894)</li>
                                        <li>Dr. Ram Krishna Singh - (Professor)-(9450538403)</li>
                                        <li>Dr. Sunil Kumar Sahni - (Assistant Professor)-(8318265088)</li>
                                        <li>Dr. Ram Yadwendra Maurya - (Assistant Professor)-(9670962308)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Hindi Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Km. Shradha Yadav - (Assistant Professor) -(8318359611)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Geography Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Ravindra Kumar Pandey - (Professor and H.O.D.)-(8957720325)</li>
                                        <li>Sri Ravi Kumar - (Assistant Professor) -(9451904564)</li>
                                        <li>Sri Ranjit Kumar Patel - (Assistant Professor) -(6388791007)</li>
                                        <li>Dr. Rama Shanker - (Assistant Professor) -(9651102246)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Sanskrit Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Pratap Kumar Mishra - (Professor and H.O.D.)-(9415697016)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Economics Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Rama Shanker Singh - (Professor and H.O.D.)-(9415653699)</li>
                                        <li>Dr. Heera Lal Singh - (Assistant Professor)-(9451710899)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Sociology Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr.(Smt.) Sarita Singh - (Professor and H.O.D.)-(9450240627)</li>
                                        <li>Smt. Raksha Singh - (Assistant Professor) -(7380335678)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>English Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>...</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>History Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Praveen Kumar Tripathi - (Assistant Professor)-(9415803728)</li>
                                        <li>Dr. Vinod Singh - (Assistant Professor)-(8004488488)</li>
                                        <li>Dr. Dileep Kumar Mishra - (Assistant Professor)-(9454818677)</li>
                                        <li>Dr. Satish Chandra Singh - (Assistant Professor)-(9838462627)</li>
                                        <li>Dr. Anand Kumar Singh - (Assistant Professor)-(9838323963)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Psychology Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Km. Shambhawi Tripathi -(Assistant Professor)-(7985441572)</li>
                                        <li>Km. Sheema Chaudhury - (Assistant Professor) -(9140110408)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Education Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Rajendra Prasad - (Professor and H.O.D.)-(9415868871)</li>
                                        <li>Dr. Rajendra Kumar Jaisawal-(Assistant Professor)-(9453370907)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Physical Education Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Sri Rahul Patel - (Assistant Professor) -(7356117275)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Home Science Department</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr.(Smt.) Saroj Singh -(Assistant Professor and H.O.D.)-(9415991379)</li>
                                        <li>Dr.(Smt.) Sweta Rai - (Assistant Professor)</li>
                                    </ol>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div>
                        <div className='bg-[#13263a] text-white text-2xl flex justify-center'><h1>B.Ed. Faculty</h1></div>
                        <div className='pl-[15px]  sm:pl-16 pb-5'>
                            <div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr.(Smt.) Kumud Tripathi - (Professor and H.O.D.)-(7376726015)</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='bg-[#13263a] text-white text-2xl flex justify-center'><h1>Commerce Faculty</h1></div>
                        <div className='pl-[15px] sm:pl-16 pb-5'>
                            <div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li> Dr. Alok Singh - (Professor and H.O.D.)-(9839354613)</li>
                                        <li>Dr. Aman Kumar - (Assistant Professor)-(9616723038)</li>
                                        <li>Sri Nitesh Kumar Yadav - (Assistant Professor) -(9696352038)</li>
                                        <li>Sri Kamlesh Kumar - (Assistant Professor) -(7505029829)</li>
                                    </ol>
                                </div>
                            </div>
                            <div>
                                <div><h1 className='text-2xl font-bold py-1 pt-4 text-purple-900'>Office Management</h1></div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                        <li>Dr. Sunil Kumar Singh - (Assistant Professor)</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='bg-[#13263a] text-white text-2xl flex justify-center'><h1>Agriculture Faculty</h1></div>
                        <div className='pl-[15px] sm:pl-16 pb-5'>
                            <div>
                                <div className='px-4'>
                                    <ol className='list-decimal'>
                                       <li>Dr. Rajesh Kumar Singh - (Assistant Professor & H.O.D.)-(9451922892)</li>
                                       <li>Dr. Nihal Khan -(Assistant Professor)-(9450031738)</li>
                                       <li>Dr. Om Prakash Singh-(Assistant Professor)-(9450356974)</li>
                                       <li>Dr. Pramod Kumar Singh -(Assistant Professor)-(9984761426)</li>
                                       <li>Dr. Rakesh Singh-(Assistant Professor)-(9454155518)</li>
                                       <li>Dr. Ajay Kumar Yadav-(Assistant Professor)-(9415699975)</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faculties
